<template>
  <div>
    <img src="@/assets/img/o_1.png" class="bjImg" alt="">
    <div class="boxCont">
      <div class="boxCont_left">
        <div class="boxCont_left_1 animate__animated animation_title">
          店星人
        </div>
        <div class="boxCont_left_1 boxCont_left_1_1 animate__animated animation_title">
          一键极速批量打单<br>发货效率飞起来
        </div>
        <div class="boxCont_left_2 animate__animated animation_title">
          多平台一键打单，实时同步，智能打单告别漏发，省时省力。一件代发，简易操作。库存管理，多店铺管理。
        </div>
        <div class="boxCont_left_3">
          <div class="boxCont_left_3_one animate__animated animation_title" @click="orderPrintingDetails">项目介绍
          </div>
          <div class="boxCont_left_3_two animate__animated animation_title" @click="downloadApp">前往官网</div>
        </div>
      </div>
      <div class="boxCont_right_one animate__animated animation_title">
        <div class="boxCont_right_one_cont elementHover" @click="orderPrintingDetails">
          <div class="boxCont_right_one_1">数据实时<span>查看</span> </div>
          <img src="@/assets/img/o_2.png" class="boxCont_right_one_2" alt="">
        </div>
      </div>
      <div class="boxCont_right_two">
        <div class="boxCont_right_two_1">
          <div class="boxCont_right_two_1_one animate__animated animation_title">
            <div class="boxCont_right_two_1_one_cont elementHover" @click="orderPrintingDetails">
              <img src="@/assets/img/o_3.png" class="boxCont_right_two_1_one_1" alt="">
            </div>
          </div>
          <div class="boxCont_right_two_1_two animate__animated animation_title">
            <div class="boxCont_right_two_1_two_cont elementHover" @click="orderPrintingDetails">
              <div class="boxCont_right_two_1_two_1">实时同步</div>
              <img src="@/assets/img/o_4.png" class="boxCont_right_two_1_two_2" alt="">
            </div>
          </div>
        </div>
        <div class="boxCont_right_two_2 animate__animated animation_title">
          <div class="boxCont_right_two_2_cont elementHover" @click="orderPrintingDetails">
            <div class="boxCont_right_two_2_one">
              <div class="boxCont_right_two_2_one_1">智能打单</div>
              <div class="boxCont_right_two_2_one_2">一键处理</div>
            </div>
            <img src="@/assets/img/o_5.png" class="boxCont_right_two_2_two" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Created by www.xingnuocn.com
  // @title: 店星人
  // @author: 刘嘉鑫
  export default {
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      // 项目介绍
      orderPrintingDetails() {
        this.$router.push({
          path: "orderPrintingDetails",
        });
      },
      // 前往官网
      downloadApp() {
        window.open("https://dianxingren.com/dxrh5/", "_blank");
      },
    }
  }
</script>

<style scoped lang="scss">
  .downToUp {
    animation-name: slideInUp !important;
  }

  @keyframes slideInUp {
    from {
      -webkit-transform: translate3d(0, 14%, 0);
      transform: translate3d(0, 14%, 0);
      visibility: visible;
    }

    to {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }


  .bjImg {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .boxCont {
    position: relative;
    z-index: 99;
    display: flex;
    justify-content: space-between;
    padding: 200px 160px 0;
  }

  .boxCont_left {

    /* width: 34%; */
    .boxCont_left_1 {
      font-weight: 700;
      font-size: 54px;
      color: #2A303A;
      line-height: 76px;
      margin-bottom: 2px;
      letter-spacing: 6px;
    }

    .boxCont_left_1_1 {
      color: #333A47;
      margin-bottom: 51px;
    }

    .boxCont_left_2 {
      font-weight: 400;
      font-size: 17px;
      color: #5D6574;
      line-height: 30px;
      margin-bottom: 70px;
      letter-spacing: 2px;
      max-width: 520px;
    }

    .boxCont_left_3 {
      display: flex;
      align-items: center;

      >div {
        border-radius: 66px;
        margin-right: 30px;
        padding: 13px 30px;
        font-weight: 700;
        font-size: 17px;
        cursor: pointer;
      }

      .boxCont_left_3_one {
        color: #FFFFFF;
        background: #0057FE;
      }

      .boxCont_left_3_two {
        background: #FFFFFF;
        color: #5D6574;
        border: 1px solid #E5E8ED;
      }
    }
  }

  .boxCont_right_one {
    margin-left: auto;
    margin-right: 30px;

    .boxCont_right_one_cont {
      background: #FFFFFF;
      border-radius: 32px;
      padding: 30px 40px 40px;
      box-shadow: 0 8px 32px rgba(42, 48, 58, 0.08);
    }

    .boxCont_right_one_1 {
      font-weight: 700;
      font-size: 30px;
      color: #0057FE;
      margin-bottom: 40px;
      letter-spacing: 3px;
      span{
        color: #222222;
      }
    }

    .boxCont_right_one_2 {
      width: 280px;
      height: 340px;
      object-fit: contain;
    }
  }

  .boxCont_right_two {
    .boxCont_right_two_1 {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 30px;
      margin-bottom: 30px;
      align-items: stretch;

      .boxCont_right_two_1_one,
      .boxCont_right_two_1_two {
        display: flex;
      }

      .boxCont_right_two_1_one {

        .boxCont_right_two_1_one_cont {
          background: #FFFFFF;
          border-radius: 32px;
          padding: 29px 28px 28px 29px;
          box-shadow: 0 8px 32px rgba(42, 48, 58, 0.08);
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          box-sizing: border-box;
        }

        .boxCont_right_two_1_one_1 {
          width: 136px;
          height: 136px;
          object-fit: contain;
        }
      }

      .boxCont_right_two_1_two {

        .boxCont_right_two_1_two_cont {
          background: linear-gradient(180deg, #DEEDFF 0%, #FFFFFF 100%);
          border-radius: 32px;
          padding: 30px 28px;
          box-shadow: 0 8px 32px rgba(42, 48, 58, 0.08);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          box-sizing: border-box;
        }

        .boxCont_right_two_1_two_1 {
          font-weight: 700;
          font-size: 24px;
          color: #333A47;
          letter-spacing: 2px;
          text-align: center;
          width: 100%;
        }

        .boxCont_right_two_1_two_2 {
          width: 72px;
          height: 72px;
          object-fit: contain;
        }
      }
    }

    .boxCont_right_two_2 {

      .boxCont_right_two_2_cont {
        background: linear-gradient(90deg, #732BEB 0%, #9251FF 100%);
        border-radius: 32px;
        padding: 30px 40px 40px;
        display: flex;
        justify-content: space-between;
      }

      .boxCont_right_two_2_one {
        font-weight: 700;
        color: #FFFFFF;
        letter-spacing: 3px;

        .boxCont_right_two_2_one_1 {
          font-size: 32px;
        }

        .boxCont_right_two_2_one_2 {
          font-size: 26px;
          margin-top: 20px;
        }
      }

      .boxCont_right_two_2_two {
        width: 172px;
        height: 148px;
        object-fit: contain;
        margin-top: 50px;
      }
    }
  }
</style>
